const EXPIRY_TIME = 7 * 24 * 60 * 60 * 1000; // 7 ngày tính bằng milliseconds

export const saveUserData = (userData) => {
  const expiryDate = new Date().getTime() + EXPIRY_TIME;
  const dataToSave = {
    ...userData,
    expiryDate
  };
  localStorage.setItem('user', JSON.stringify(dataToSave));
};

export const getUserData = () => {
  const userData = localStorage.getItem('user');
  if (!userData) return null;

  const { expiryDate, ...user } = JSON.parse(userData);
  const now = new Date().getTime();

  // Kiểm tra xem dữ liệu đã hết hạn chưa
  if (now > expiryDate) {
    localStorage.removeItem('user');
    return null;
  }

  return user;
};

export const removeUserData = () => {
  localStorage.removeItem('user');
}; 